export default "__VITE_ASSET__f27c09d3__"